import * as React from 'react';

/**
 * Context for providing a custom container element for portals.
 * This allows portals (modals, sheets, dropdowns, etc.) to render inside
 * a themed container rather than document.body, ensuring they inherit
 * CSS variable overrides from parent theme wrappers (e.g., .v1-app-shell).
 */
const PortalContainerContext = React.createContext<HTMLElement | null>(null);

export function usePortalContainer(): HTMLElement | null {
  return React.useContext(PortalContainerContext);
}

export function PortalContainerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [container, setContainer] = React.useState<HTMLElement | null>(null);

  return (
    <PortalContainerContext.Provider value={container}>
      <div ref={setContainer} className="contents">
        {children}
      </div>
    </PortalContainerContext.Provider>
  );
}
